import React from 'react';
import { Tab } from '@mui/material';
import { CountLabel, RecordTabs } from 'components/record-shell/RecordShell';

interface HospitalTabProps {
  tab: string;
  onChange: (newTab: string) => void;
  // hospital já cadastrado: a ficha é a primeira aba
  showRecord?: boolean;
  proceduresCount?: number;
  banksCount?: number;
}

const HospitalTab: React.FC<HospitalTabProps> = ({ tab, onChange, showRecord, proceduresCount, banksCount }) => {
  return (
    <RecordTabs tab={tab} onChange={onChange}>
      {showRecord && <Tab value="record" label="Ficha" />}
      <Tab value="main" label="Dados do hospital" />
      <Tab value="address" label="Endereço" />
      <Tab value="procedures" label={<CountLabel label="Procedimentos" count={proceduresCount} />} />
      <Tab value="banks" label={<CountLabel label="Dados bancários" count={banksCount} />} />
    </RecordTabs>
  );
};

export default HospitalTab;
